// Debounced Toast Service Plugin
// Wraps PrimeVue's ToastService to prevent duplicate toast messages

const DebouncedToastService = {
  install: (app) => {
    const toastQueue = new Map();
    const DEBOUNCE_TIME = 600; // milliseconds

    // Create a debounced version of the toast add method
    const originalToast = app.config.globalProperties.$toast;

    if (originalToast) {
      const debouncedAdd = (message) => {
        // Create a unique key based on message content
        const key = JSON.stringify({
          severity: message.severity,
          summary: message.summary,
          detail: message.detail,
          group: message.group
        });

        // Check if this message is already queued
        if (toastQueue.has(key)) {
          // Clear the existing timeout
          clearTimeout(toastQueue.get(key));
        }

        // Set a new timeout
        const timeoutId = setTimeout(() => {
          originalToast.add(message);
          toastQueue.delete(key);
        }, DEBOUNCE_TIME);

        toastQueue.set(key, timeoutId);
      };

      // Override the add method with debounced version
      app.config.globalProperties.$toast = {
        add: debouncedAdd,
        removeGroup: originalToast.removeGroup?.bind(originalToast),
        removeAllGroups: originalToast.removeAllGroups?.bind(originalToast)
      };
    }
  }
};

export default DebouncedToastService;
